import { render, staticRenderFns } from "./materialDelivery.vue?vue&type=template&id=21e0b452&scoped=true"
import script from "./materialDelivery.vue?vue&type=script&lang=js"
export * from "./materialDelivery.vue?vue&type=script&lang=js"
import style0 from "./materialDelivery.vue?vue&type=style&index=0&id=21e0b452&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0b452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e0b452')) {
      api.createRecord('21e0b452', component.options)
    } else {
      api.reload('21e0b452', component.options)
    }
    module.hot.accept("./materialDelivery.vue?vue&type=template&id=21e0b452&scoped=true", function () {
      api.rerender('21e0b452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/components/materialDelivery.vue"
export default component.exports